/**
 * Promo bundle — add multiple variants + optional discount (Cart API).
 */
(function () {
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-promo-bundle-form]');
    if (!form) return;
    e.preventDefault();

    const wrap = form.closest('[data-promo-bundle]');
    if (!wrap || typeof theme === 'undefined' || !theme.routes || !theme.utils) return;

    const raw = wrap.getAttribute('data-bundle-variant-ids');
    if (!raw) return;

    const ids = raw
      .split(',')
      .map(function (s) {
        return parseInt(s.trim(), 10);
      })
      .filter(function (n) {
        return n > 0;
      });
    if (!ids.length) return;

    const discount = (wrap.getAttribute('data-discount-code') || '').trim();
    const btn = form.querySelector('[type="submit"]');
    const activeEl = btn || form;

    if (form.hasAttribute('data-loading')) return;
    form.setAttribute('data-loading', '');
    btn?.setAttribute('aria-busy', 'true');
    btn?.setAttribute('disabled', '');

    const items = ids.map(function (id) {
      return { id: id, quantity: 1 };
    });

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const body = JSON.stringify({
      items: items,
      sections: sectionsToBundle,
      sections_url: window.location.pathname
    });

    fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), body: body })
      .then(function (response) {
        return response.json();
      })
      .then(async function (parsedState) {
        if (parsedState.status) {
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:error', {
              detail: { errorMessage: parsedState.description || parsedState.message }
            })
          );
          return;
        }

        let cartJson;
        if (discount) {
          const cartRes = await fetch(theme.routes.cart_url + '.js', { ...theme.utils.fetchConfig('json', 'GET') });
          const cartBefore = await cartRes.json();
          const existing = (cartBefore.discount_codes || [])
            .map(function (d) {
              return d.code;
            })
            .filter(Boolean);
          const merged = existing.concat([discount]).filter(function (v, i, a) {
            return a.indexOf(v) === i;
          });
          cartJson = await (await fetch(theme.routes.cart_update_url, {
            ...theme.utils.fetchConfig('json'),
            body: JSON.stringify({
              discount: merged.join(','),
              sections: sectionsToBundle,
              sections_url: window.location.pathname
            })
          })).json();
        }
        else {
          cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
          if (parsedState.sections) cartJson.sections = parsedState.sections;
        }

        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'promo-bundle', cart: cartJson });
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: { product: parsedState }
          })
        );

        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show(activeEl);
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        form.removeAttribute('data-loading');
        btn?.removeAttribute('aria-busy');
        btn?.removeAttribute('disabled');
      });
  });
})();
